import { useEffect } from 'react';

import { useAppDispatch } from 'redux/hooks';
import { setPriceList, setSeasons, setUserTypes, setZones } from 'redux/slices/constants';

import { usersDataService } from 'services/users.service';

const useUsers = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    usersDataService.getSeasons().then((res) => dispatch(setSeasons(res.data)));
    usersDataService.getZones(true).then((res) => dispatch(setZones(res.data)));
    usersDataService.getPriceList().then((res) => dispatch(setPriceList(res.data)));
    usersDataService.getUserTypes().then((res) => dispatch(setUserTypes(res.data)));
  }, []);
};

export { useUsers };
